import { render, staticRenderFns } from "./maintenanceCreateRequest.vue?vue&type=template&id=6401a0d6&scoped=true"
import script from "./maintenanceCreateRequest.ts?vue&type=script&lang=ts&external"
export * from "./maintenanceCreateRequest.ts?vue&type=script&lang=ts&external"
import style0 from "./maintenanceCreateRequest.vue?vue&type=style&index=0&id=6401a0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401a0d6",
  null
  
)

export default component.exports